import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Navbar from "../component/Header.js/Navbar/Navbar";
import styled from "styled-components";
import ImagesSLider from "../component/UI/ImagesSlider";
import {
  Add,
  CheckCircle,
  CheckCircleOutline,
  CurrencyRupee,
  LocalShipping,
  LocationOn,
  Remove,
  Favorite,
  FavoriteBorder,
  ShareOutlined,
  WhatsApp,
  Facebook,
  ContentCopy,
  Check,
} from "@mui/icons-material";
import card from "../assets/images/cards/card.jpg";
import FullPageLoader from "../component/Loaders/CategoryLoader/FullPageLoader";
import Footer from "../component/Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import FeatureProductBox from "../component/UI/FeatureProductBox";
import BtnLoader from "../component/Loaders/CategoryLoader/BtnLoader";
import CompLoader from "../component/Loaders/CompLoader/CompLoader";

const MainBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 10rem;
  position: relative;
  overflow-x: hidden;
  @media only screen and (max-width: 949px) {
    padding: 1rem 2rem;
  }
`;

// Product Info and slider

const SliderAndProductInfoBox = styled.div`
  display: grid;
  width: 90%;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;

  @media only screen and (max-width: 949px) {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 2rem;
    height: auto;
  }
`;

const ProductInfoBox = styled.div`
  padding: 0 2rem;
  display: flex;
  gap: 1rem;
  flex-direction: column;
  text-align: justify;
  h1 {
    margin-bottom: -1.5rem;
    text-transform: capitalize;
    font-size: 2.7rem;
    font-weight: bold;
  }
  h3 {
    font-size: 2.1rem;
    display: flex;
    gap: 1rem;
    align-items: end;
    i {
      text-decoration: line-through;

      color: #cac9c9;
      font-family: "Times New Roman", Times, serif;
      font-size: 1.6rem;
    }
  }
  p {
    color: #7d7d7d;
    font-size: 1.6rem;
  }
  @media only screen and (max-width: 949px) {
    padding: 0;

    h1 {
      font-size: 2rem;
    }
  }
`;

const ColorAndInfoBox = styled.div`
  display: flex;
  height: fit-content;
  align-items: center;
  gap: 1rem;
  position: relative;
  color: #7d7d7d;
  font-size: 1.6rem;
`;
const ColorBox = styled.div`
  height: 4rem;
  width: 3rem;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  span {
    visibility: hidden;
    position: absolute;
    top: -2rem;
    z-index: 2;
    background-color: black;
    padding: 0.3rem 0.5rem 0.7rem 0.5rem;
    border-radius: 0.5rem;
    text-transform: capitalize;
    color: white;
    transition: all 0.1s;
    clip-path: polygon(
      0% 0%,
      100% 0%,
      100% 75%,
      75% 75%,
      53% 92%,
      32% 75%,
      0% 75%
    );
  }
  i {
    width: 1.7rem;
    height: 1.7rem;
    border-radius: 50%;
    cursor: pointer;
    opacity: 0.7;
    display: flex;

    &:hover {
      outline: 1px solid black;
      outline-offset: 2px;
      opacity: 1;
    }
  }
  &:hover {
    span {
      visibility: visible;
    }
  }
`;

const AddToCartDiv = styled.div`
  display: flex;
  gap: 2rem;
  min-height: 5rem;
  position: relative;
  width: 100%;
  max-width: 45rem;
  align-items: stretch;

  > button {
    flex: 1 1 12rem;
    min-height: 4rem;
    text-transform: uppercase;
    background-color: black;
    color: white;
    border: none;
    padding: 0.7rem 1.2rem;
    white-space: nowrap;
  }

  > select,
  > span {
    flex: 1 1 16rem;
    min-width: 0;
  }

  @media only screen and (max-width: 600px) {
    flex-wrap: wrap;
    gap: 1rem;

    > button {
      flex-basis: 100%;
      width: 100%;
    }
  }
`;

const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
`;

const PriceText = styled.h3`
  font-size: 2.3rem;
  display: flex;
  gap: 1rem;
  align-items: center;
  margin: 0;

  .mrp {
    color: #777;
    font-size: 1.5rem;
    font-weight: normal;
  }

  i {
    text-decoration: line-through;
    color: #cac9c9;
    font-family: "Times New Roman", Times, serif;
    font-size: 1.6rem;
    font-style: normal;
  }

  .discount {
    color: #e0204d;
    font-size: 1.6rem;
    font-weight: 600;
  }
`;

const HeaderActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  position: relative;
`;

const WishlistIconButton = styled.button`
  background-color: ${props => props.isWishlisted ? "#fff0f3" : "#fff"} !important;
  color: ${props => props.isWishlisted ? "#ff3f6c" : "#222"} !important;
  border: 1px solid ${props => props.isWishlisted ? "#ff3f6c" : "#ccc"} !important;
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
  min-width: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);

  &:hover {
    background-color: ${props => props.isWishlisted ? "#ffe6eb" : "#f5f5f5"} !important;
    border-color: ${props => props.isWishlisted ? "#e0204d" : "#000"} !important;
    transform: scale(1.05);
  }

  svg {
    font-size: 2.2rem;
    color: ${props => props.isWishlisted ? "#ff3f6c" : "#333"};
  }
`;

const ShareContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ShareIconButton = styled.button`
  background-color: #fff !important;
  color: #222 !important;
  border: 1px solid #ccc !important;
  border-radius: 50%;
  width: 4rem;
  height: 4rem;
  min-width: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);

  &:hover {
    background-color: #f5f5f5 !important;
    border-color: #000 !important;
    transform: scale(1.05);
  }

  svg {
    font-size: 2.2rem;
    color: #333;
  }
`;

const ShareTooltipBox = styled.div`
  position: absolute;
  bottom: calc(100% + 10px);
  right: 0;
  background-color: #000000;
  color: #ffffff;
  padding: 0.6rem 1.2rem;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 1.2rem;
  z-index: 100;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.25);
  white-space: nowrap;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    right: 14px;
    border-width: 6px;
    border-style: solid;
    border-color: #000000 transparent transparent transparent;
  }

  span {
    font-size: 1.1rem;
    font-weight: 700;
    letter-spacing: 1px;
    color: #ffffff;
    text-transform: uppercase;
  }

  button {
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    transition: transform 0.2s, color 0.2s;
    &:hover {
      transform: scale(1.15);
      color: #511d00;
    }
  }

  a {
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease, opacity 0.2s ease;

    &:hover {
      opacity: 0.8;
      transform: scale(1.15);
    }
  }
`;

const InpBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  button {
    height: 4rem;
    background-color: white;
    border: 1px solid #e9e9e9;
    color: black;
    svg {
      color: black;
    }
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: none;
  }
`;

const CheckOutBox = styled.div`
  padding: 1rem 0;
  /* background-color: red; */
  h4 {
    position: relative;
    font-size: 2rem;
    z-index: 1;
    margin: 1rem 0;
    overflow: hidden;
    text-align: center;
    color: #aaa9a9;
    &::before,
    &::after {
      position: absolute;
      top: 50%;
      overflow: hidden;
      width: 50%;
      height: 1px;

      content: "\a0";
      background-color: #e5e3e3;
    }
    &::before {
      margin-left: -50%;
      text-align: right;
    }
  }
  img {
    width: 30rem;
    display: block;
    margin: 0 auto;
    opacity: 0.9;
  }
  ul {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    /* background-color: red; */
    justify-content: center;
    align-items: center;
    li {
      display: block;
      margin: 0 auto;
      color: #7d7d7d;
      font-size: 1.6rem;
      list-style: circle;
      text-transform: capitalize;
      width: 100%;

      @media only screen and (max-width: 949px) {
        margin: 0;
        margin-left: -5rem;
      }
      span {
        display: flex;
        justify-content: space-between;
        span {
          text-align: start;
        }
      }
    }
  }
`;

const MoneyInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  h5 {
    text-transform: capitalize;
    font-weight: bold;
  }
  span {
    p {
      display: flex;
      gap: 0.5rem;
      align-items: center;
      color: #6b6b6b;
      text-transform: capitalize;
    }
  }
`;

const OutOfStockPara = styled.h2`
  font-size: 3rem;
  letter-spacing: 0.1rem;
  font-weight: bold;
  color: #bb1313;
`;

// Desc
const DescBox = styled.div`
  display: flex;

  flex-direction: column;
  margin-top: 3rem;
  padding: 2rem 0;
  gap: 2rem;
  @media only screen and (max-width: 949px) {
  }
`;

const ImgAndTextbox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  align-items: center;
  gap: 2rem;

  @media only screen and (max-width: 949px) {
    display: none;
  }
`;
const ImgAndTextBoxMobile = styled.div`
  overflow-x: hidden;
  display: none;
  @media only screen and (max-width: 949px) {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
`;

const ImgBox = styled.div`
  display: flex;
  justify-content: center;
  background-color: #f7f7f7;
  img {
    width: 45%;
    @media only screen and (max-width: 949px) {
      width: 80%;
    }
  }
`;

const TextBox = styled.div`
  display: flex;

  flex-direction: column;
  gap: 2rem;
  padding: 0 2rem;
  h5 {
    font-size: 2.7rem;
    font-weight: bold;
    letter-spacing: 0.1rem;
    text-transform: capitalize;
    text-align: center;
    @media only screen and (max-width: 949px) {
      font-size: 2rem;
    }
  }
  p {
    text-align: center;
    color: #7d7d7d;
    font-size: 1.5rem;
    letter-spacing: 0.1rem;
    @media only screen and (max-width: 949px) {
      font-size: 1.1rem;
    }
  }
  @media only screen and (max-width: 949px) {
    gap: 0;
  }
`;

const RelatedProductBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 2rem 0;
`;

const MainBoxProducts = styled.section`
  padding: 1rem 0;
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  overflow-x: hidden;
  position: relative;
`;

const ProductsBox = styled.div`
  height: fit-content;
  display: flex;
  gap: 3rem;
  padding: 1rem 0;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  width: fit-content;
  max-width: 100%;
  justify-content: start;
  position: relative;
  height: fit-content;
  overflow-x: scroll;
  @media only screen and (max-width: 949px) {
    width: 90%;
    max-width: 90%;
    justify-content: start;
  }
  scroll-behavior: smooth;
  &::-webkit-scrollbar {
    display: none;
  }
  a {
    text-decoration: none;
    color: black;
  }
`;
const Select = styled.select`
  padding: 1rem 1.5rem;
  border: none;
  color: #777;
  background-color: white;
  border-radius: 1rem;
  font-size: 1.3rem;
  font-weight: bold;
  letter-spacing: 0.04rem;
  border: 1px solid #777;
  border-style: dotted;
  &:focus {
    outline: none;
    border: none;
    border: 1px solid #777;
    border-style: dotted;
  }
  @media only screen and (max-width: 1099px) {
    padding: 1rem 0;
  }
`;
const Option = styled.option`
  color: #777;
  font-weight: bold;
`;

const ErrDiv = styled.div`
  color: red;
`;

const AddedToCart = styled.div`
  color: black;
`;

const RzrpayDiv = styled.div`
  width: 100%;
  height: fit-content;
`;

const ColorPincodeBox = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media only screen and (max-width: 949px) {
    flex-direction: column;
    align-items: start;
    gap: 1rem;
  }
`;

const PinCodeInnerBox = styled.div`
  background-color: white;
  padding: 0.4rem 1rem;
  display: flex;
  align-items: center;
  border-radius: 0.5rem;
  border: 1px solid #e1e1e1;
  width: 60%;
  @media only screen and (max-width: 949px) {
    width: 100%;
  }
`;

const Input = styled.input`
  border: none;
  width: 80%;
  padding: 0 1rem;
  &:focus {
    outline: none;
  }
`;

const CheckButton = styled.button`
  border: none;
  background-color: black;
  color: white;
  padding: 0.6rem 1.4rem;
  border-radius: 0.5rem;
  width: 20%;
  @media only screen and (max-width: 949px) {
    width: 30%;
  }
`;

const DeliveryResultBox = styled.div`
  background-color: #f6f6f9;
  width: 65%;
  height: fit-content;
  border-radius: 0.8rem;
  border: 1px solid #e1e1e1;
  display: flex;
  flex-direction: column;

  padding: 2rem;
  padding-top: 1rem;
  gap: 1rem;
  @media only screen and (max-width: 949px) {
    width: 100%;
  }
`;
const DeliveryResultTextBox = styled.div`
  border: 1px solid #c5c5c5;
  border-style: dashed;
  background-color: white;
  padding: 1rem 2rem;
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    align-items: center;
    padding: 0.2rem;
    gap: 1rem;
    margin-bottom: 0.1rem;
    /* width: 100%; */
    svg {
      color: black;
      &:first-child {
        color: #57c13d;
      }
    }
  }
  @media only screen and (max-width: 949px) {
    /* padding: 0.2rem 0.1rem; */
    p {
      font-size: 1.38rem;
    }
    div {
      gap: 0.5rem;
    }
  }
`;
const ParaBox = styled.div`
  color: black;
`;

const FullWidthDetailsSection = styled.section`
  width: 90%;
  margin: 3.5rem auto 1.5rem auto;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  background-color: #ffffff;
  border-radius: 1rem;
  border: 1px solid #ebebeb;
  padding: 3rem 3.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);

  @media only screen and (max-width: 949px) {
    width: 100%;
    padding: 2rem 1.5rem;
    margin-top: 2rem;
  }
`;

const ShippingTrustBanner = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  padding: 2rem 2.5rem;
  background: linear-gradient(135deg, #fdfbf9 0%, #f7f3ee 100%);
  border: 1px solid #ecdcd1;
  border-radius: 0.8rem;

  @media only screen and (max-width: 949px) {
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    padding: 1.5rem;
  }
  @media only screen and (max-width: 550px) {
    grid-template-columns: 1fr;
  }
`;

const TrustItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;

  .icon-wrap {
    width: 4.2rem;
    height: 4.2rem;
    min-width: 4.2rem;
    border-radius: 50%;
    background-color: #511d00;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      font-size: 2.2rem;
    }
  }

  .text-wrap {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    h6 {
      margin: 0;
      font-size: 1.4rem;
      font-weight: 700;
      color: #222;
      text-transform: capitalize;
    }
    p {
      margin: 0;
      font-size: 1.2rem;
      color: #666;
    }
  }
`;

const SpecificationsHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  border-bottom: 2px solid #511d00;
  padding-bottom: 1rem;

  h3 {
    margin: 0;
    font-size: 2.2rem;
    font-weight: 700;
    color: #222;
    text-transform: uppercase;
    letter-spacing: 0.08rem;
  }
`;

const SpecificationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;

  @media only screen and (max-width: 949px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media only screen and (max-width: 550px) {
    grid-template-columns: 1fr;
  }
`;

const SpecCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.4rem 1.6rem;
  background-color: #faf8f5;
  border-radius: 0.6rem;
  border: 1px solid #ebdcd5;

  .spec-label {
    font-size: 1.15rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05rem;
    color: #8c6239;
    margin-bottom: 0.4rem;
  }

  .spec-value {
    font-size: 1.5rem;
    font-weight: 600;
    color: #222;
    text-transform: capitalize;
    word-break: break-word;
  }
`;

const ProductPage = (props) => {
  const cartItems = useSelector((state) => state.cartItems);
  const [deliveryDate, setDeliveryDate] = useState(null);
  const [product, setProduct] = useState(null);
  const [products, setProducts] = useState([]);
  const [deliveryResult, setDeliveryResult] = useState(null);
  const [pinLoading, setPinLoading] = useState(false);
  const [colors, setColors] = useState(null);
  const [selectedClr, setSelectedClr] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [productAdded, setProductAdded] = useState(false);
  const productId = useParams().productId;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [cartError, setCartError] = useState(false);
  const [selectedSize, setSelectedSize] = useState(null);
  const [maxQ, setMAxQ] = useState(false);
  const [wishlistAdded, setWishlistAdded] = useState(false);
  const [wishlistRemoved, setWishlistRemoved] = useState(false);
  const [wishlistLoginError, setWishlistLoginError] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [copiedLink, setCopiedLink] = useState(false);
  const shareRef = useRef(null);
  const dispatch = useDispatch();
  let counter = 0;
  const navigate = useNavigate();

  const handleCopyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopiedLink(true);
    setTimeout(() => {
      setCopiedLink(false);
    }, 2500);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (shareRef.current && !shareRef.current.contains(event.target)) {
        setShowShareMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  const isLoggedIn = useSelector((state) => state.isLoggedIn);
  const userId = useSelector((state) => state.userId);
  const wishlistItems = useSelector((state) => state.wishlistItems) || [];
  const isWishlisted = product ? wishlistItems.some((item) => item.id === product.id) : false;

  const toggleWishlistHandler = async () => {
    if (!isLoggedIn) {
      setWishlistLoginError(true);
      setTimeout(() => {
        setWishlistLoginError(false);
        navigate("/login");
      }, 1500);
      return;
    }

    try {
      if (isWishlisted) {
        const res = await fetch(`${process.env.REACT_APP_BASE_URL}/user/wishlist/remove`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ userId, productId: product.id }),
        });
        const data = await res.json();
        if (data.success) {
          dispatch({ type: "removeFromWishlist", productId: product.id });
          setWishlistRemoved(true);
          setTimeout(() => {
            setWishlistRemoved(false);
          }, 2000);
        }
      } else {
        const res = await fetch(`${process.env.REACT_APP_BASE_URL}/user/wishlist/add`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ userId, productId: product.id }),
        });
        const data = await res.json();
        if (data.success) {
          dispatch({ type: "addToWishlist", product: product });
          setWishlistAdded(true);
          setTimeout(() => {
            setWishlistAdded(false);
          }, 2000);
        }
      }
    } catch (err) {
      console.error("Wishlist toggle error:", err);
    }
  };
  const getSelectValueHandler = () => {
    setError(false);
    const e = document.getElementById("searchFilter");

    const value = e.options[e.selectedIndex].value;
    setSelectedSize(value);
  };

  function shuffle(array) {
    let currentIndex = array.length,
      randomIndex;

    while (currentIndex > 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }

    return array;
  }

  let swicther = true;
  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    const fetcher = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/product/${productId}`
      );
      const data = await res.json();

      if (!data.product || data.product.status === false) {
        navigate("/not-found");
        return;
      }

      setProduct(data.product);
      setSelectedClr(data.product.color);
      const clrArr = data.product.color.split(",");
      setColors(clrArr);

      const resProducts = await fetch(
        `${process.env.REACT_APP_BASE_URL}/product/all-items`
      );
      const dataProducts = await resProducts.json();
      setProducts(shuffle(dataProducts.products));
      const key = process.env.REACT_APP_RAZORPAY_KEY;

      const widgetConfig = {
        key: key,
        amount: Math.round(Number(data.product.price) * 100),
        currency: "INR",
      };
      const rzpAffordabilitySuite = await new window.RazorpayAffordabilitySuite(
        widgetConfig
      );
      await rzpAffordabilitySuite.render();
    };
    fetcher();

    return () => {};
  }, [productId]);

  //Replace it with your Test Key ID generated from the Dashboard
  // const amount = product ? product.amount : 40000; //in paise

  const quantityAdder = () => {
    if (quantity < 2) {
      setQuantity(quantity + 1);
    }
  };
  const quantutyMinus = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  // const colorSelecter = (e) => {
  //   const id = e.target.id;
  //   setSelectedClr(id);
  //   setErr(false);

  //   const allELe = document.querySelectorAll(".clrBox");
  //   for (const el of allELe) {
  //     el.style.outline = "";
  //     el.style.outlineOffset = "";
  //     el.style.opacity = ".7";
  //   }
  //   const ele = document.querySelector(`#${id}`);
  //   ele.style.outline = "1px solid black";
  //   ele.style.outlineOffset = "2px";
  //   ele.style.opacity = "1";
  // };

  const isProductHasSizes =
    product &&
    (product.hasSizes === true ||
      product.hasSizes === "true" ||
      (Array.isArray(product.stock) &&
        product.stock.some((sz) => {
          for (const k in sz) {
            if (Number(sz[k]) > 0) return true;
          }
          return false;
        })));

  const isFootwear =
    product &&
    (product.sizeType === "footwear" ||
      (product.category && product.category.toLowerCase().includes("footwear")) ||
      [
        "slippers-slides",
        "sandals",
        "mojaris-mules",
        "loafers-close-shoe",
        "heels",
        "girls-footwears",
        "footwear",
      ].includes(product.category?.toLowerCase()) ||
      (Array.isArray(product.stock) &&
        product.stock.some((s) =>
          Object.keys(s).some((k) =>
            ["3", "4", "5", "6", "7", "8", "9", "10"].includes(k)
          )
        )));

  const effectiveSize = isProductHasSizes ? selectedSize : "Standard";

  const addToCartHandler = async () => {
    setError(false);
    if (isProductHasSizes && !selectedSize) {
      setError(true);
      return;
    }
    setIsLoading(true);
    const titleArr = product.title.split(" ");
    let title;
    if (titleArr[1]) {
      title = titleArr[0] + " " + titleArr[1];
    } else {
      title = titleArr[0];
    }
    const obj = {
      title: title,
      productId: productId,
      price: product.price,
      image: product.images.split(" ")[0],
      quantity: quantity,
      color: selectedClr,
      size: effectiveSize,
      category: product.category,
      slug: product.slug,
      stockAvailable: Number(product.generalStock || 10),
    };

    // Stock Verifier
    const alreadyFound = cartItems.find((item) => {
      if (item.size === obj.size) {
        return item.productId === obj.productId;
      }
      return false;
    });
    if (
      alreadyFound &&
      Number(alreadyFound.quantity) + Number(obj.quantity) > 2
    ) {
      setMAxQ(true);
      setIsLoading(false);
      setTimeout(() => {
        setMAxQ(false);
      }, 1500);
      return;
    }

    try {
      const stockVerifier = await fetch(
        `${process.env.REACT_APP_BASE_URL}/product/stock`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            productId: product.id,
            quantity: alreadyFound ? Number(alreadyFound.quantity) + obj.quantity : obj.quantity,
            size: effectiveSize,
          }),
        }
      );
      const stockData = await stockVerifier.json();
      console.log(stockData);
      if (stockData.add) {
        setProductAdded(true);
        dispatch({ type: "addToCart", product: { ...obj } });
        if (isProductHasSizes) setSelectedSize(null);
      } else {
        setCartError(true);
        setTimeout(() => {
          setCartError(false);
        }, 2000);
      }
    } catch (e) {
      console.error(e);
    }

    if (isProductHasSizes) setSelectedSize(null);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    setTimeout(() => {
      setProductAdded(false);
    }, 1500);
  };

  return (
    <>
      {!product && <FullPageLoader />}

      {product && (
        <>
          <Navbar />
          <MainBox>
            {product && (
              <>
                <SliderAndProductInfoBox>
                  <ImagesSLider product={product} />
                  {/* data-aos="fade-left" */}
                  <ProductInfoBox>
                    <h1>{product.title}</h1>
                    <PriceRow>
                      <PriceText>
                        ₹ {Number(product.price).toLocaleString("en-IN")}
                        {product.discount > 0 && (
                          <>
                            <span className="mrp">MRP</span>
                            <i>
                              ₹
                              {Number.parseInt(
                                (Number(product.price) * 100) /
                                  (100 - Number(product.discount))
                              ).toLocaleString("en-IN")}
                            </i>
                            <span className="discount">{product.discount}% off</span>
                          </>
                        )}
                      </PriceText>
                      <HeaderActionButtons>
                        <WishlistIconButton
                          isWishlisted={isWishlisted}
                          onClick={toggleWishlistHandler}
                          title={isWishlisted ? "Wishlisted" : "Add to Wishlist"}
                        >
                          {isWishlisted ? <Favorite /> : <FavoriteBorder />}
                        </WishlistIconButton>
                        <ShareContainer ref={shareRef}>
                          <ShareIconButton
                            onClick={() => setShowShareMenu((prev) => !prev)}
                            title="Share product"
                          >
                            <ShareOutlined />
                          </ShareIconButton>
                          {showShareMenu && (
                            <ShareTooltipBox>
                              <span>SHARE</span>
                              <button
                                type="button"
                                onClick={handleCopyLink}
                                title={copiedLink ? "Link Copied!" : "Copy Link"}
                              >
                                {copiedLink ? (
                                  <Check style={{ fontSize: "1.9rem", color: "#4caf50" }} />
                                ) : (
                                  <ContentCopy style={{ fontSize: "1.8rem" }} />
                                )}
                              </button>
                              <a
                                href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                                  product.title + " " + window.location.href
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Share on WhatsApp"
                              >
                                <WhatsApp style={{ fontSize: "1.9rem" }} />
                              </a>
                              <a
                                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                                  window.location.href
                                )}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Share on Facebook"
                              >
                                <Facebook style={{ fontSize: "1.9rem" }} />
                              </a>
                              <a
                                href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                                  window.location.href
                                )}&text=${encodeURIComponent(product.title)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Share on X"
                              >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                                </svg>
                              </a>
                            </ShareTooltipBox>
                          )}
                        </ShareContainer>
                      </HeaderActionButtons>
                    </PriceRow>
                    <p>{product.desc}</p>
                    <RzrpayDiv>
                      <div id="razorpay-affordability-widget"></div>
                    </RzrpayDiv>
                    <ColorPincodeBox>
                      <ColorAndInfoBox>
                        Color :
                        {colors.map((clr) => {
                          return (
                            <ColorBox key={product.id + clr}>
                              <span>{clr}</span>
                              <i
                                className="clrBox"
                                id={clr.trim()}
                                style={{ backgroundColor: `${clr}` }}
                              ></i>
                            </ColorBox>
                          );
                        })}
                      </ColorAndInfoBox>
                      {!deliveryResult && (
                        <PinCodeInnerBox id="pincodeInner">
                          <LocationOn />
                          <Input
                            type="number"
                            max={6}
                            id="pinCode"
                            placeholder="Enter pincode"
                            onChange={() => {
                              const pinCode =
                                document.querySelector("#pinCode");
                              const pincodeInner =
                                document.querySelector("#pincodeInner");

                              pincodeInner.style.border = "1px solid #e1e1e1";
                              pinCode.placeholder = "Enter pincode";
                              return;
                            }}
                          />
                          <CheckButton
                            onClick={async () => {
                              setPinLoading(true);
                              const pinCode =
                                document.querySelector("#pinCode");
                              const pincodeInner =
                                document.querySelector("#pincodeInner");
                              if (pinCode.value.length < 6) {
                                pinCode.value = "";
                                pincodeInner.style.border = "1px solid red";
                                pinCode.placeholder = "Enter valid pincode";
                                return;
                              }
                              if (pinCode.value.length > 6) {
                                pinCode.value = "";
                                pincodeInner.style.border = "1px solid red";
                                pinCode.placeholder = "Enter valid pincode";
                                return;
                              }
                              const reslt = await fetch(
                                `${process.env.REACT_APP_BASE_URL}/shipping/check-delivery`,
                                {
                                  method: "POST",
                                  headers: {
                                    "Content-Type": "application/json",
                                  },
                                  body: JSON.stringify({
                                    pinCode: pinCode.value,
                                  }),
                                }
                              );
                              const data = await reslt.json();
                              setDeliveryResult(data);
                              console.log(data);
                              setPinLoading(false);
                              pinCode.value = "";
                              // alert(data.message + `: ${data.data.city}`);
                              var date = new Date();
                              date.setDate(date.getDate() + 10);
                              setDeliveryDate(date.toString().split(" "));
                            }}
                          >
                            Check
                          </CheckButton>
                        </PinCodeInnerBox>
                      )}
                    </ColorPincodeBox>
                    {deliveryResult && (
                      <DeliveryResultBox data-aos="zoom-in">
                        {pinLoading && <CompLoader />}
                        {deliveryResult.available && (
                          <h4>Available at {deliveryResult.data[0].city}</h4>
                        )}
                        {!deliveryResult.available && (
                          <h4>Not available at your pincode.</h4>
                        )}
                        <DeliveryResultTextBox>
                          {deliveryResult.available && (
                            <p style={{ color: "#57C13D" }}>
                              We are available and serving at your location.
                            </p>
                          )}
                          {!deliveryResult.available && (
                            <p style={{ color: "red" }}>
                              We are not available at your location. Stay tuned
                              for updates.
                            </p>
                          )}
                          {deliveryResult.available && (
                            <>
                              <div>
                                {" "}
                                <CheckCircleOutline />
                                <LocalShipping />
                                <ParaBox>
                                  <strong>Expected Delivery -</strong>
                                  <span>
                                    {deliveryDate[0]}, {deliveryDate[1]}{" "}
                                    {deliveryDate[2]}
                                  </span>
                                </ParaBox>
                              </div>
                              <div>
                                <CheckCircleOutline />
                                <CurrencyRupee />
                                <ParaBox>
                                  <strong>Payment -</strong>
                                  <span>Online Only</span>
                                </ParaBox>
                              </div>
                            </>
                          )}
                        </DeliveryResultTextBox>
                        <CheckButton
                          onClick={() => {
                            setDeliveryResult(null);
                          }}
                        >
                          Change
                        </CheckButton>
                      </DeliveryResultBox>
                    )}
                    <AddToCartDiv>
                      {isLoading && <BtnLoader />}
                      {!isLoading && (
                        <>
                          <InpBox>
                            <button onClick={quantityAdder}>
                              <Add onClick={quantityAdder} />
                            </button>
                            <button>{quantity}</button>
                            <button onClick={quantutyMinus}>
                              <Remove onClick={quantutyMinus} />
                            </button>
                          </InpBox>
                          {isProductHasSizes ? (
                            <Select
                              name="searchFilter"
                              id="searchFilter"
                              value={selectedSize || ""}
                              onChange={getSelectValueHandler}
                            >
                              <Option value="">
                                {isFootwear ? "Select Footwear Size (UK/IND)" : "Select Size"}
                              </Option>
                              {Array.isArray(product.stock) &&
                                product.stock.map((i) => {
                                  for (const k in i) {
                                    if (Number(i[k]) > 0) {
                                      const isNumeric = !isNaN(Number(k));
                                      const isFootwearSize = isFootwear || isNumeric;
                                      return (
                                        <Option key={k} value={k}>
                                          {isFootwearSize
                                            ? `UK / IND Size ${k} (${i[k]} left)`
                                            : `Size : ${k.toUpperCase()} (${i[k]} left)`}
                                        </Option>
                                      );
                                    }
                                  }
                                  return null;
                                })}
                            </Select>
                          ) : (
                            <span
                              style={{
                                padding: "0.8rem 1.4rem",
                                backgroundColor: "#f5f5f5",
                                borderRadius: "0.8rem",
                                fontSize: "1.3rem",
                                fontWeight: "600",
                                color: "#555",
                                border: "1px dashed #c0c0c0",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              Standard Size
                            </span>
                          )}
                          <button onClick={addToCartHandler}>
                            add to cart
                          </button>
                        </>
                      )}
                    </AddToCartDiv>
                    {productAdded && (
                      <AddedToCart data-aos="fade-right">
                        Added to cart
                      </AddedToCart>
                    )}
                    {wishlistAdded && (
                      <AddedToCart data-aos="fade-right">
                        Added to wishlist
                      </AddedToCart>
                    )}
                    {wishlistRemoved && (
                      <AddedToCart data-aos="fade-right">
                        Removed from wishlist
                      </AddedToCart>
                    )}
                    {maxQ && (
                      <AddedToCart data-aos="fade-right">
                        Max quantity reached.
                      </AddedToCart>
                    )}
                    {error && <ErrDiv data-aos="fade-up">Select Size</ErrDiv>}
                    {wishlistLoginError && (
                      <ErrDiv data-aos="fade-up">
                        Please login to use the wishlist
                      </ErrDiv>
                    )}
                    {cartError && (
                      <ErrDiv data-aos="fade-up">
                        Stock not available, please reduce quantity
                      </ErrDiv>
                    )}
                    <CheckOutBox>
                      <h4>Safe Checkout</h4>
                      <img src={card} alt="Safe Checkout" />
                    </CheckOutBox>
                  </ProductInfoBox>
                </SliderAndProductInfoBox>

                <FullWidthDetailsSection>
                  <ShippingTrustBanner>
                    <TrustItem>
                      <div className="icon-wrap">
                        <LocalShipping />
                      </div>
                      <div className="text-wrap">
                        <h6>Free Shipping</h6>
                        <p>On all orders over ₹999 across India</p>
                      </div>
                    </TrustItem>

                    <TrustItem>
                      <div className="icon-wrap">
                        <CheckCircle />
                      </div>
                      <div className="text-wrap">
                        <h6>100% Secure Payments</h6>
                        <p>UPI, Cards &amp; Net Banking</p>
                      </div>
                    </TrustItem>

                    <TrustItem>
                      <div className="icon-wrap">
                        <CheckCircleOutline />
                      </div>
                      <div className="text-wrap">
                        <h6>Hassle-Free Returns</h6>
                        <p>Easy 7-day replacement &amp; return</p>
                      </div>
                    </TrustItem>

                    <TrustItem>
                      <div className="icon-wrap">
                        <CurrencyRupee />
                      </div>
                      <div className="text-wrap">
                        <h6>Best Price Guarantee</h6>
                        <p>Authentic quality direct from store</p>
                      </div>
                    </TrustItem>
                  </ShippingTrustBanner>

                  <SpecificationsHeader>
                    <h3>Details &amp; Specifications</h3>
                  </SpecificationsHeader>

                  <SpecificationsGrid>
                    <SpecCard>
                      <span className="spec-label">Product Name</span>
                      <span className="spec-value">{product.title}</span>
                    </SpecCard>

                    <SpecCard>
                      <span className="spec-label">Category</span>
                      <span className="spec-value">{product.category}</span>
                    </SpecCard>

                    {product.fabric && (
                      <SpecCard>
                        <span className="spec-label">Fabric / Material</span>
                        <span className="spec-value">{product.fabric}</span>
                      </SpecCard>
                    )}

                    {product.color && (
                      <SpecCard>
                        <span className="spec-label">Color</span>
                        <span className="spec-value">{product.color}</span>
                      </SpecCard>
                    )}

                    <SpecCard>
                      <span className="spec-label">Country Of Origin</span>
                      <span className="spec-value">INDIA</span>
                    </SpecCard>

                    {product.discount > 0 && (
                      <SpecCard>
                        <span className="spec-label">Special Offer</span>
                        <span className="spec-value" style={{ color: "#e0204d" }}>
                          {product.discount}% Discount
                        </span>
                      </SpecCard>
                    )}

                    {isProductHasSizes && (
                      <SpecCard>
                        <span className="spec-label">Sizing Type</span>
                        <span className="spec-value">
                          {isFootwear ? "UK / IND Footwear Sizing" : "Standard Apparel Sizes"}
                        </span>
                      </SpecCard>
                    )}

                    {product.metaData &&
                      Array.isArray(product.metaData) &&
                      product.metaData
                        .filter((m) => m && m.key && m.key.trim() !== "")
                        .map((m, idx) => (
                          <SpecCard key={idx}>
                            <span className="spec-label">{m.key}</span>
                            <span className="spec-value">{m.value}</span>
                          </SpecCard>
                        ))}
                  </SpecificationsGrid>
                </FullWidthDetailsSection>
              </>
            )}
          </MainBox>
          <Footer />
        </>
      )}
    </>
  );
};

export default ProductPage;
